<template>
  <div class="container">
      <div class="col-lg-6 col-md-6 mt-3 ml-auto mr-auto">
        <form @submit.prevent="handleSubmit()">
          <card class="card-register card-white">
            <template slot="header">
              <img class="card-img" style="top: 0px" src="/dist/img/card-primary.png" alt=""/>
              <h4 class="card-title">Cont nou</h4>
            </template>
            <br>
            <br>
              <base-input
                v-model="name"
                placeholder="Nume"
                addon-left-icon="tim-icons icon-single-02"
                type="text">
              </base-input>
              <validation-error :errors="apiValidationErrors.name" />

              <base-input
                v-model="email"
                placeholder="Email"
                addon-left-icon="tim-icons icon-email-85"
                type="email">
              </base-input>
              <validation-error :errors="apiValidationErrors.email" />

              <base-input
                v-model="password"
                placeholder="Parola"
                addon-left-icon="tim-icons icon-lock-circle"
                type="password">
              </base-input>
              <validation-error :errors="apiValidationErrors.password" />

              <base-input
                placeholder="Confirma Parola"
                type="password"
                name="Password confirmation"
                v-model="password_confirmation"
                addon-left-icon="tim-icons icon-lock-circle">
              </base-input>
              <validation-error :errors="apiValidationErrors.password_confirmation" />

            <base-checkbox v-model="boolean" class="text-left">
              Sunt de acord cu <a href="#something">termenii si conditiile</a>.
            </base-checkbox>

            <base-button native-type="submit" slot="footer" type="primary" round block size="lg">
              Inregistreaza-te
            </base-button>
          </card>
        </form>
      </div>
  </div>
</template>
<script>

import { BaseCheckbox } from '@/components';
import ValidationError from "@/components/ValidationError.vue";
import formMixin from "@/mixins/form-mixin";

export default {
  components: {
    BaseCheckbox,
    ValidationError
  },
  mixins: [formMixin],
  data() {
    return {
      name: null,
      boolean: false,
      email: null,
      password: null,
      password_confirmation: null,

    };
  },
  methods: {
    async handleSubmit() {
      if (!this.boolean) {
         await this.$notify({
          type: 'danger',
          message: 'You need to agree with our terms and conditions.',
          icon: 'tim-icons icon-bell-55',
        })
        return;
      }

      const user = {
        data: {
          type: "token",
          attributes: {
            name: this.name,
            email: this.email,
            password: this.password,
            password_confirmation: this.password_confirmation,
          },
        },
      };

      const requestOptions = {
        headers: {
          Accept: "application/vnd.api+json",
          "Content-Type": "application/vnd.api+json",
        },
      };

      try {
        await this.$store.dispatch("register", { user, requestOptions });
         this.$notify({
          type: 'succes',
          message: 'Successfully registered.',
          icon: 'tim-icons icon-bell-55',
        })
      } catch (error) {
         this.$notify({
          type: 'danger',
          message: 'Oops, something went wrong!',
          icon: 'tim-icons icon-bell-55',
        })
      }
    }
  }
};
</script>
<style></style>
